import { Grid } from "@mui/material";
import { Icons } from "../assets/icons";

export const PermissionErrorComponent = () => {
    const fullScreenMsg = {
      padding: '0 60px 60px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    };
  
    return (
      <Grid style={fullScreenMsg}>
        <Grid
          style={{
            color: 'black',
            backgroundColor: '#fff',
            padding: '120px 40px',
            borderRadius: '10px',
            minWidth: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
          }}
        >
          <div className="icon">
            <img src={Icons.IconDeniedGraphics} alt="SI Track" />
          </div>
          <div className="content" style={{ textAlign: 'left', paddingLeft: '60px' }}>
            <h1 style={{ marginBottom: '20px' }}>Access Denied!</h1>
            <p>You don&apos;t have permission to access this page.</p>
          </div>
        </Grid>
      </Grid>
    );
  };